<template>
  <model-form
    ref="modelForm"
    :model="priceCardItem"
    :submodel="true"
    modal-type="modal"
  >
    <div class="row q-col-gutter-md">
      <q-select
        v-model="type"
        class="col-6"
        :options="$mh.asOptions(PRICE_CARD_ITEM_TYPES.ALL)"
        emit-value
        map-options
        :rules="[val => !!val || 'Field is required']"
        :disable="priceCardItem.isRemote"
        label="Type"
      />
      <q-select
        v-if="type === PRICE_CARD_ITEM_TYPES.PACKAGE"
        v-model="priceCardItem.itemPackage"
        class="col-6"
        :options="$_.filter(itemPackages.data, pack => !pack.itemOnlyPackage)"
        bottom-slots
        option-label="name"
        :rules="[val => !!val || 'Field is required']"
        label="Item Package"
      />
      <q-select
        v-if="type === PRICE_CARD_ITEM_TYPES.TICKET"
        v-model="priceCardItem.ticketType"
        class="col-6"
        :options="$_.filter(ticketTypes.data, ticketType => !ticketType.isArchived)"
        bottom-slots
        option-label="name"
        :rules="[val => !!val || 'Field is required']"
        label="Ticket Type"
      />
    </div>
    <div
      v-if="type === PRICE_CARD_ITEM_TYPES.TICKET"
      class="row q-col-gutter-md"
    >
      <q-toggle
        v-model="priceCardItem.hasCustomPrice"
        class="col-6"
        label="Override Price"
        bottom-slots
      />
      <q-input
        v-if="priceCardItem.hasCustomPrice"
        v-model.number="priceCardItem.customPrice"
        class="col-6"
        label="Custom Price"
        :prefix="currentCircuit.localeCurrencySymbol"
        type="number"
        bottom-slots
      />
    </div>
  </model-form>
</template>

<script>
import { PRICE_CARD_ITEM_TYPES } from 'src/models/showing/PriceCardItem'
import ModelForm from 'src/modules/admin/components/ModelForm/ModelForm'

export default {
  name: 'InventoryItemUnitForm',
  components: {
    ModelForm
  },
  configuration: ['currentCircuit', 'ticketTypes', 'itemPackages'],
  data () {
    return {
      type: null
    }
  },
  models: {
    priceCardItem: 'default'
  },
  watch: {
    'priceCardItem.id' () {
      this.type = this.priceCardItem.type
    },
    type () {
      this.priceCardItem.isDirty && this.priceCardItem.revert()
    }
  },
  created () {
    _.extend(this, { PRICE_CARD_ITEM_TYPES })
  }
}
</script>

<style lang="scss" scoped>
</style>
